import React, { useState } from 'react';
import { ICreatableReactSelectOption } from '../../../utils/types';
import CategoriesMenu from '../CategoriesMenu';
import { defaultManagedOption } from '../utils';
import { TextButton } from '../../Button';

interface IProps {
  schemaId: string;
  selectedValues: ICreatableReactSelectOption[];
  onChange: (values: ICreatableReactSelectOption[]) => void;
  isManaged: boolean;
}

const ApplyTags = ({
  schemaId,
  selectedValues,
  onChange,
  isManaged,
}: IProps) => {
  const [showMenu, setShowMenu] = useState(false);

  if (!showMenu && selectedValues.length === 0) {
    return (
      <TextButton onClick={() => setShowMenu(true)}>+ Apply Tags</TextButton>
    );
  }

  const categoriesWithManaged = isManaged
    ? [defaultManagedOption, ...selectedValues]
    : selectedValues;

  return (
    <CategoriesMenu
      schemaId={schemaId}
      selectedValues={categoriesWithManaged}
      onChange={onChange}
    />
  );
};

export default ApplyTags;
